<template>
    <div id="nav">
        <ul class="report-nav">
            <li>
              <router-link to="/">
                <span class="mdi mdi-home"></span> Report Home
              </router-link>
            </li>
            <li v-for="(section, idx) in sections" :key="idx">
              <router-link to="section/12345">
                {{ section.number }} {{ section.name }}
              </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            sections: Array
        }
    }
</script>

<style lang="scss">
    ul.report-nav {
        overflow-y: scroll;
        height: 100%;
        margin-top: -70px;
        margin-left: -30px;        
        max-width: 300px;
        background: white;

        li {
            margin-left: 20px;
        }
        
        li:first-child {
            margin-top: 70px;
        }
    }
</style>